import { RadioInput as RadioInputZebra } from '@trmediaab/zebra-components';

import { useDomSafeId } from '../../utils/useDomSafeId';

interface RadioInputProps extends React.ComponentProps<typeof RadioInputZebra> {
  label: string;
  name: string;
  value: string | number;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioInput = ({
  label,
  name,
  value,
  checked,
  containerStyles,
  onChange,
  ...props
}: RadioInputProps) => {
  const id = useDomSafeId();
  return (
    <RadioInputZebra
      id={id}
      name={name}
      value={value}
      checked={checked}
      label={label}
      onChange={onChange}
      containerStyles={containerStyles}
      buttonStyles={{
        checkedColor: 'checkout.checkboxSelected',
      }}
      labelStyles={{
        fontWeight: 'semiBold',
        fontSize: [1, null, 2],
        color: checked ? 'checkout.checkboxSelected' : 'inherit',
        width: '100%',
      }}
      {...props}
    />
  );
};
